import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import { itemCountLabel, statusColors } from './userActivityTypes.utils';

type OrderDeliveredProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_DELIVERED'>;
};

export const OrderDelivered = ({ entry }: OrderDeliveredProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="check-circle-filled"
    color={statusColors.positive}
    title="Order delivered"
    summary={
      <SummaryItems
        items={[
          {
            key: 'order',
            content: entry.order_id,
            copyText: entry.order_id,
            label: 'Order ID',
          },
          {
            key: 'fulfillment',
            content: entry.fulfillment_id,
            copyText: entry.fulfillment_id,
            label: 'Fulfillment ID',
          },
          { key: 'items', content: itemCountLabel(entry.line_items) },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
